import { useCallback } from "react";

import {
  AnalyticsComponent,
  AnalyticsFieldName,
  ExploreResourcesAnalyticsEvent,
} from "@/constants/analytics/Analytics";
import { ExploreTestID } from "@/constants/TestID";
import { useAnalytics } from "@/services/Analytics";
import InformationalAccordion from "@/ui/composed/cards/InformationalAccordion";

enum WhyCompleteAssessmentsConstants {
  Description = "Your responses to these to-dos help us deliver evidence-based care that works. With the information you share, your provider will personalize your treatment plan during your intake appointment.",
  Title = "Why it’s important to complete these to-dos before your intake appointment",
}

const WhyCompleteAssessmentsAccordion = () => {
  const { track } = useAnalytics();

  const handleTriggerPress = useCallback(
    (isOpen: boolean) => {
      track(ExploreResourcesAnalyticsEvent.InformationalBlurbRead, {
        Action: isOpen ? "Expand" : "Collapse",
        [AnalyticsFieldName.Component]: AnalyticsComponent.Accordion,
        [AnalyticsFieldName.Title]: WhyCompleteAssessmentsConstants.Title,
      });
    },
    [track],
  );

  return (
    <InformationalAccordion
      description={WhyCompleteAssessmentsConstants.Description}
      onTriggerPress={handleTriggerPress}
      shouldDefaultToOpen
      testID={ExploreTestID.WhyCompleteAssessmentsAccordion}
      title={WhyCompleteAssessmentsConstants.Title}
    />
  );
};

export { WhyCompleteAssessmentsConstants };
export default WhyCompleteAssessmentsAccordion;
